import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RecoverPasswordUserAction } from '../../../redux/actions/user';
import { RECOVER_PASSWORD_USER_RESET } from '../../../redux/constantes/user';

import ContainerLogin from '../../../components/Login/ContainerLogin';
import LogoLogin from '../../../components/Login/LogoLogin';
import FooterLogin from '../../../components/Login/FooterLogin';
import WrapperButton from '../../../components/Login/WrapperButton';
import InputLogin from '../../../components/Login/InputLogin';
import ButtonLogin from '../../../components/Login/ButtonLogin';
import ButtonRedirect from '../../../components/Login/ButtonRedirect';
import MainLogin from '../../../components/Login/MainLogin';
import { MessageErrorLogin, MessageSuccessRecover } from '../../../components/Login/MessagesLogin';

export default function TemplateRecoverPassword() {
  const [email, setEmail] = useState('');

  const {
    success: successRecover,
    error: errorRecover,
    loading: loadingRecover,
  } = useSelector((state) => state.recoverPasswordUser);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    dispatch(RecoverPasswordUserAction(email));
  };

  useEffect(() => {
    if (successRecover) {
      setTimeout(() => {
        dispatch({ type: RECOVER_PASSWORD_USER_RESET });
        document.location.href = '/login';
      }, 2000);
    }
    if (errorRecover) {
      setTimeout(() => {
        dispatch({ type: RECOVER_PASSWORD_USER_RESET });
      }, 3000);
    }
  }, [successRecover, dispatch, errorRecover]);

  return (
    <ContainerLogin>
      <MainLogin>
        <LogoLogin />
        <InputLogin
          pathIcon="/images/icons/mail.svg"
          name="Email"
          type="email"
          placeholder="exemplo@email.com"
          onInputChange={(v) => setEmail(v)}
          value={email}
        />
        {successRecover && <MessageSuccessRecover>Nova senha enviada por email!</MessageSuccessRecover>}
        {errorRecover && <MessageErrorLogin>{errorRecover}</MessageErrorLogin>}
        <WrapperButton>
          <ButtonRedirect href="/login">Voltar</ButtonRedirect>
          <ButtonLogin name="entrar" onClick={handleSubmit} disabled={loadingRecover}>
            {loadingRecover ? 'Aguarde...' : 'Enviar para Email'}
          </ButtonLogin>
        </WrapperButton>
      </MainLogin>
      <FooterLogin />
    </ContainerLogin>
  );
}
